import { baseApi } from "../baseApi";

export const taxcategoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTaxCategoryList: builder.query({
      query: (params) => ({
        url: `/api/resource/Tax Category`,
        params
      }),
    }),
    getPurchaseTaxCategoryList: builder.query({
      query: (selectedCompany) => ({
        url: `/api/resource/Purchase Taxes and Charges Template?filters=${encodeURIComponent(
          JSON.stringify({ company: selectedCompany.split(" - ")[0], disabled: 0 })
        )}`
      }),
    }),
    getSalesTaxCategoryList: builder.query({
      query: (selectedComapny) => ({
        url: `/api/resource/Sales Taxes and Charges Template?filters=${encodeURIComponent(
          JSON.stringify({ company: selectedComapny.split(" - ")[0], disabled: 0 })
        )}`,
      }),
    }),
  }),
});

export const { useGetTaxCategoryListQuery, useGetPurchaseTaxCategoryListQuery, useGetSalesTaxCategoryListQuery } = taxcategoryApi;
